import "./index.scss";

import React from "react";

const Badge = ({ number = 0, className }) => {
  return <div className={`text-inside ${className}`}>{number > 99 ? "99+" : number}</div>;
};

export default Badge;
